import { RegisterModule } from '@/typings/common'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import {
  SessionsState,
  SessionsGetters,
  SessionsMutations,
  SessionsActions,
} from './store'
import { MODULE_NAME } from '../utils'

const storeModule = (
  new Module({
    namespaced: true,
    state: SessionsState,
    getters: SessionsGetters,
    mutations: SessionsMutations,
    actions: SessionsActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as sessionsStoreModule,
  mapper as sessionsMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
